import SteelImage from "./assets/Steel.png";
import { AlertSnackbar } from "./components/Snackbar";
import WalletConnectDialog from "./components/WalletConnectDialog";
import Header from "./components/Header";
import useNetworkListener from "./lib/hooks/useNetworkListener";
import NFTCarousel from "./components/NFTCarousel";
import Footer from "./components/Footer";
import AccountInfo from "./components/AccountInfo";

function App() {
  useNetworkListener();

  return (
    <>
      <div className="relative w-full min-h-screen flex justify-center items-center">
        <img
          src={SteelImage}
          className="absolute w-full h-full inset-0 object-cover"
          alt="Steel"
        />
        <div className="w-full md:w-auto relative z-20 bg-black h-full flex flex-col items-center text-white md:rounded-md">
          <Header />
          <div className="md:py-12 px-4 md:px-24 space-y-12 flex flex-col items-center">
            <NFTCarousel />
            <AccountInfo />
            <Footer />
          </div>
        </div>
      </div>
      <WalletConnectDialog />
      <AlertSnackbar />
    </>
  );
}

export default App;
